import { Pipe, PipeTransform } from '@angular/core';
import { AcceleratorCatalog } from 'src/app/components/catalogs/accelerator-catalog/services/accelerator-catalog';

@Pipe({
  name: 'sharedChangesTooltip',
  pure: true
})
export class SharedChangesTooltipPipe implements PipeTransform {

  transform(
    acceleratorCatalog: AcceleratorCatalog | null | undefined,
    data: AcceleratorCatalog[] | null | undefined,
    template: string | null | undefined
  ): string {
    const currentAccelerator = acceleratorCatalog?.details?.accelerator;
    if (!currentAccelerator || !template) {
      return '';
    }

    const sharedParentIds = acceleratorCatalog?.sharedChangesParentsIDs ?? [];
    if (!sharedParentIds.length) {
      return template
        .replaceAll('{this}', currentAccelerator.name ?? '')
        .replaceAll('{other}', '');
    }

    const otherResources = (data ?? [])
      .map(item => item?.details?.accelerator)
      .filter(
        (resource): resource is NonNullable<typeof resource> =>
          !!resource && sharedParentIds.includes(resource.id)
      )
      .map(resource => resource.name)
      .join(', ');

    return template
      .replaceAll('{this}', currentAccelerator.name ?? '')
      .replaceAll('{other}', otherResources);
  }
}